import { render, staticRenderFns } from "./vRecipeBreakdownTable.vue?vue&type=template&id=e4693c58&scoped=true"
import script from "./vRecipeBreakdownTable.vue?vue&type=script&lang=ts"
export * from "./vRecipeBreakdownTable.vue?vue&type=script&lang=ts"
import style0 from "./vRecipeBreakdownTable.vue?vue&type=style&index=0&id=e4693c58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4693c58",
  null
  
)

export default component.exports